import { render, staticRenderFns } from "./GjwTabs.vue?vue&type=template&id=2f3d3151&scoped=true&"
import script from "./GjwTabs.vue?vue&type=script&lang=js&"
export * from "./GjwTabs.vue?vue&type=script&lang=js&"
import style0 from "./GjwTabs.vue?vue&type=style&index=0&id=2f3d3151&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3d3151",
  null
  
)

export default component.exports